import { createRouter, createWebHistory } from 'vue-router'
const routes=[
  {path:'/',name:'Home',component:()=>import('@/view/MainPage.vue')},
  {path:'/tech',name:'Tech',component:()=>import('@/view/TechScien.vue')},
  {path:'/us',name:'Us',component:()=>import('@/view/AboutUs.vue')},
  {path:'/policy',name:'Policy',component:()=>import('@/view/PoliDyna.vue')},
  {path:'/join',name:'Join',component:()=>import('@/view/JoinUs.vue')}
  ,{path:'/dashboard',name:'Dashboard',component:()=>import('@/view/DashboardPage.vue')}
]
export default createRouter({history:createWebHistory(process.env.BASE_URL),routes,scrollBehavior:to=>to.hash?{el:to.hash,top:78,behavior:'smooth'}:{left:0,top:0,behavior:'auto'}})
